__turbopack_context__.v({
  "box": "ConsentReset-module__8nasha__box",
  "status": "ConsentReset-module__8nasha__status",
});
